<template>
  <div id="app">

    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  //祖先组件向其所有子孙后代注入一个依赖
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive: true
    }
  },
  methods:{
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true
      });
    }
  }
}
</script>

<style lang="stylus" type="text/stylus">
@import "assets/iconfont/iconfont.css";
@import "./assets/css/element-ui-initialize.styl";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/**
 * 适配 iphone 底部安全区（指示条，配合index.html <meta name="viewport" ... />使用
 <meta name="viewport"
        content="width=device-width, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0, viewport-fit=cover">
 */
@supports (bottom: env(safe-area-inset-bottom)){
  #app {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}

ul {
  list-style: none;
}

a {
  color: #2c3e50;
  cursor: pointer;
}
a:hover {
  color: #466EF2;
}
ul, li, a {

  text-decoration: none;
}
.el-message {
  min-width: 65%;
  height: 50px;
}

img {
  display: block;
}
input:focus {
  outline: none;
}
.el-form-item__error {
  left: inherit !important;
  right: 0 !important;
}
.is-error input {
  border-color: #F56C6C !important

}

.el-message {
  .el-icon-info, .el-message__icon {
    font-size .2em
  }
}

#app {
  font-family: "Microsoft YaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  width: 100%;
  height: 100%;
  color: #2c3e50;

}

</style>



// WEBPACK FOOTER //
// src/App.vue